const getEnvData = (env) => process.env[env] || null;

const awsconfig = {
  Auth: {

    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: getEnvData('VUE_APP_COGNITO_IDENTITY_POOL_ID'),

    // REQUIRED - Amazon Cognito Region
    region: getEnvData('VUE_APP_COGNITO_REGION'),

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: getEnvData('VUE_APP_COGNITO_USER_POOL_ID'),

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: getEnvData('VUE_APP_COGNITO_WEB_CLIENT_POOL_ID'),

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    // mandatorySignIn: false,

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie
    // transmission requires a secure protocol
    // cookieStorage: {
    //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //   domain: getEnvData('VUE_APP_COOKIE_DOMAIN'),
    //   // OPTIONAL - Cookie path
    //   path: '/',
    //   // OPTIONAL - Cookie expiration in days
    //   expires: 365,
    //   // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    //   // sameSite: 'strict',
    //   // OPTIONAL - Cookie secure flag
    //   // Either true or false, indicating if the cookie transmission
    //   // requires a secure protocol (https).
    //   secure: false,
    // },
  },
  API: {
    endpoints: [
      {
        name: getEnvData('VUE_APP_LAMBDA_API_NAME'),
        endpoint: getEnvData('VUE_APP_LAMBDA_HOST'),
        region: getEnvData('VUE_APP_COGNITO_REGION'),
      },
    ],
  },
  Storage: {
    AWSS3: {
      // bucket: 'plf-config-prod',
      // bucket: 'plf-frontend-assets',
      bucket: getEnvData('VUE_APP_S3_BUCKET_NAME'),
      region: getEnvData('VUE_APP_COGNITO_REGION'),
    },
  },
};
export default awsconfig;
